// extracted by mini-css-extract-plugin
module.exports = {"menu":"_type_menu__PKffH"};